import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/Footer.css';

const Footer = () => {
    // const currentYear = new Date().getFullYear();
    const currentYear = "2023"

    return (
        <footer className="footer">
            <div className="footer-content">
                <div className="container">
                    <div className="footer-sections">
                        {/* Company Info */}
                        <div className="footer-section">
                            <div className="footer-logo">
                                <img src="/logo/logo.jpeg" alt="MapLube Logo" />
                                <span>MapLube</span>
                            </div>
                            <p>Leading provider of high-quality lubricants and oils in India. Trusted by millions of customers for engine protection and performance.</p>
                            <div className="social-links">
                                <a href="https://www.facebook.com/maplube" target="_blank" rel="noopener noreferrer" className="social-link" title="Follow us on Facebook">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="social-icon">
                                        <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"></path>
                                    </svg>
                                </a>
                                <a href="https://www.instagram.com/maplube" target="_blank" rel="noopener noreferrer" className="social-link" title="Follow us on Instagram">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="social-icon">
                                        <rect width="20" height="20" x="2" y="2" rx="5" ry="5"></rect>
                                        <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path>
                                        <line x1="17.5" x2="17.51" y1="6.5" y2="6.5"></line>
                                    </svg>
                                </a>
                                <a href="https://twitter.com/maplube" target="_blank" rel="noopener noreferrer" className="social-link" title="Follow us on Twitter">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="social-icon">
                                        <path d="M22 4s-.7 2.1-2 3.4c1.6 10-9.4 17.3-18 11.6 2.2.1 4.4-.6 6-2C3 15.5.5 9.6 3 5c2.2 2.6 5.6 4.1 9 4-.9-4.2 4-6.6 7-3.8 1.1 0 3-1.2 3-1.2z"></path>
                                    </svg>
                                </a>
                                <a href="https://www.linkedin.com/company/maplube" target="_blank" rel="noopener noreferrer" className="social-link" title="Follow us on LinkedIn">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="social-icon">
                                        <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"></path>
                                        <rect width="4" height="12" x="2" y="9"></rect>
                                        <circle cx="4" cy="4" r="2"></circle>
                                    </svg>
                                </a>
                            </div>
                        </div>

                        {/* Quick Links */}
                        <div className="footer-section">
                            <h3>Quick Links</h3>
                            <ul className="footer-links">
                                <li><Link to="/">Home</Link></li>
                                <li><Link to="/about">About Us</Link></li>
                                <li><Link to="/products">Products</Link></li>
                                <li><Link to="/industries">Industries</Link></li>
                                <li><Link to="/quality-assurance">Quality</Link></li>
                                <li><Link to="/dealership">Dealership</Link></li>
                            </ul>
                        </div>

                        {/* Products */}
                        <div className="footer-section">
                            <h3>Products</h3>
                            <ul className="footer-links">
                                <li><Link to="/products#two-wheeler">Two-Wheeler Oils</Link></li>
                                <li><Link to="/products#car">Car Engine Oils</Link></li>
                                <li><Link to="/products#commercial">Commercial Vehicle Oils</Link></li>
                                <li><Link to="/products#agricultural">Agricultural Oils</Link></li>
                                <li><Link to="/products#industrial">Industrial Lubricants</Link></li>
                                <li><Link to="/products">View All Products</Link></li>
                            </ul>
                        </div>

                        {/* Support */}
                        <div className="footer-section">
                            <h3>Support</h3>
                            <ul className="footer-links">
                                <li><Link to="/contact">Contact Us</Link></li>
                                <li><Link to="/faq">FAQ</Link></li>
                                <li><Link to="/blog">Blog</Link></li>
                                <li><a href="#">Technical Support</a></li>
                                <li><a href="#">Download TDS</a></li>
                                <li><a href="#">Warranty Information</a></li>
                            </ul>
                        </div>

                        {/* Contact Info */}
                        {/* <div className="footer-section">
                            <h3>Contact Info</h3>
                            <div className="contact-info">
                                <div className="contact-item">
                                    <span className="contact-icon">📞</span>
                                    <div>
                                        <p>+91 9540 071804</p>
                                        <span>Mon-Fri: 9:00 AM - 6:00 PM</span>
                                    </div>
                                </div>
                                <div className="contact-item">
                                    <span className="contact-icon">✉️</span>
                                    <div>
                                        <p>contact@maplube.in</p>
                                        <span>We'll respond within 24 hours</span>
                                    </div>
                                </div>
                                <div className="contact-item">
                                    <span className="contact-icon">📍</span>
                                    <div>
                                        <p>10130A, 10th Floor, Gaur City Mall</p>
                                        <span>Sector 4, Greater Noida-201318, India</span>
                                    </div>
                                </div>
                            </div>
                        </div> */}
                    </div>
                </div>
            </div>

            {/* Footer Bottom */}
            <div className="footer-bottom">
                <div className="container">
                    <div className="footer-bottom-content">
                        <div className="copyright">
                            <p>&copy; {currentYear} MapLube. All rights reserved.</p>
                        </div>
                        <div className="footer-bottom-links">
                            <a href="#">Privacy Policy</a>
                            <a href="#">Terms of Service</a>
                            <a href="#">Cookie Policy</a>
                            <a href="#">Sitemap</a>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
